import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const detail = {
  title: '降龙咒',
  content: [
    '天龙天龙，<br />听吾号令，',
    '速归本位，<br />不得违令，',
    '降服天龙，<br />护我宅安。'
  ],
  description: '降龙咒为道家镇宅要咒，用于降服宅内不安之龙气，保家安宁。',
  usage: [
    '家中出现异常响动时诵读',
    '农历每月十四日效果最佳',
    '配合五帝钱使用效果更佳',
    '诚心诵读，不可儿戏'
  ]
};

const FuzouDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 to-pink-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-4xl">
          <button
            onClick={() => navigate('/fuzou')}
            className="flex items-center text-purple-800 mb-8 hover:text-purple-600 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            返回符咒列表
          </button>

          <div className="bg-white rounded-2xl shadow-xl border-2 border-purple-200 overflow-hidden">
            <div className="bg-gradient-to-r from-purple-500 to-pink-500 py-6 text-center">
              <h1 className="text-3xl font-bold text-white font-serif tracking-widest">
                {detail.title}
              </h1>
            </div>

            <div className="p-8">
              <p className="text-gray-600 mb-8 italic text-center">
                降服天龙，镇宅安宅
              </p>

              <div className="space-y-4 text-xl sm:text-2xl font-medium text-gray-800 leading-relaxed font-serif text-center mb-10">
                {detail.content.map((line, index) => (
                  <p key={index} dangerouslySetInnerHTML={{ __html: line }}></p>
                ))}
              </div>

              <div className="space-y-6">
                <div className="bg-purple-50 rounded-xl p-6 border border-purple-100">
                  <h3 className="text-lg font-bold text-purple-900 mb-3">咒语说明</h3>
                  <p className="text-gray-700">{detail.description}</p>
                </div>

                <div className="bg-purple-50 rounded-xl p-6 border border-purple-100">
                  <h3 className="text-lg font-bold text-purple-900 mb-3">使用方法</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    {detail.usage.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FuzouDetail;
